import { Link } from "react-router-dom";
import { MapPin, ChevronRight } from "lucide-react";
import { US_STATES, CARIBBEAN_LOCATIONS, CATEGORIES } from "@/lib/constants";

export default function Sitemap() {
  const states = Object.values(US_STATES);
  
  return (
    <div className="min-h-screen bg-stone-50" data-testid="sitemap-page">
      {/* Header */}
      <section className="bg-white border-b border-stone-200 py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="font-heading font-bold text-3xl sm:text-4xl text-stone-900">
            Sitemap
          </h1>
          <p className="mt-2 text-stone-600">
            Browse all locations and categories on Paradise Borrowed
          </p>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Main Pages */}
        <section className="mb-12">
          <h2 className="font-heading font-semibold text-xl text-stone-900 mb-4 flex items-center gap-2">
            <ChevronRight className="w-5 h-5 text-coral" />
            Main Pages
          </h2>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
            {[
              { name: "Home", path: "/" },
              { name: "Browse Items", path: "/browse" },
              { name: "Dispute Resolution", path: "/trust" },
              { name: "Sign Up", path: "/auth" },
              { name: "Log In", path: "/auth" },
              { name: "Terms of Service", path: "/terms-of-service" },
              { name: "Privacy Policy", path: "/privacy-policy" },
            ].map((page) => (
              <Link
                key={page.path + page.name}
                to={page.path}
                className="text-sm text-stone-600 hover:text-coral transition-colors"
              >
                {page.name}
              </Link>
            ))}
          </div>
        </section>

        {/* Caribbean Destinations */}
        <section className="mb-12">
          <h2 className="font-heading font-semibold text-xl text-stone-900 mb-4 flex items-center gap-2">
            <MapPin className="w-5 h-5 text-coral" />
            Caribbean Destinations
          </h2>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
            {CARIBBEAN_LOCATIONS.map((loc) => (
              <Link
                key={loc.name}
                to={`/${loc.name.toLowerCase().replace(/\s+/g, "-")}`}
                className="text-sm text-stone-600 hover:text-coral transition-colors"
              >
                {loc.name}
              </Link>
            ))}
          </div>
        </section>

        {/* US States & Cities */}
        <section className="mb-12">
          <h2 className="font-heading font-semibold text-xl text-stone-900 mb-6 flex items-center gap-2">
            <MapPin className="w-5 h-5 text-coral" />
            United States Locations
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {states.map((state) => (
              <div key={state.slug} className="bg-white rounded-xl border border-stone-200 p-5">
                <Link
                  to={`/${state.slug}`}
                  className="font-heading font-semibold text-stone-900 hover:text-coral transition-colors text-base mb-3 block"
                >
                  {state.name}
                </Link>
                <div className="grid grid-cols-2 gap-x-4 gap-y-1">
                  {state.cities.map((city) => (
                    <Link
                      key={city.slug}
                      to={`/${state.slug}/${city.slug}`}
                      className="text-xs text-stone-500 hover:text-coral transition-colors truncate"
                    >
                      {city.name}
                    </Link>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Categories */}
        <section className="mb-12">
          <h2 className="font-heading font-semibold text-xl text-stone-900 mb-4 flex items-center gap-2">
            <ChevronRight className="w-5 h-5 text-coral" />
            Categories
          </h2>
          <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-6 gap-3">
            {CATEGORIES.map((cat) => (
              <Link
                key={cat.name}
                to={`/browse?category=${encodeURIComponent(cat.name)}`}
                className="text-sm text-stone-600 hover:text-coral transition-colors"
              >
                {cat.name}
              </Link>
            ))}
          </div>
        </section>

        {/* XML Sitemap Link */}
        <section className="text-center py-8 border-t border-stone-200">
          <p className="text-sm text-stone-500">
            For search engines:{" "}
            <a
              href="/sitemap.xml"
              className="text-coral hover:underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              XML Sitemap
            </a>
          </p>
        </section>
      </div>
    </div>
  );
}
